import { render, staticRenderFns } from "./ExpressOrderTableUserHead.vue?vue&type=template&id=4b995c8b&scoped=true"
import script from "./ExpressOrderTableUserHead.vue?vue&type=script&lang=js"
export * from "./ExpressOrderTableUserHead.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b995c8b",
  null
  
)

export default component.exports